export default __webpack_public_path__ + "static/media/why2.f9b4b22b.png";